import { render, staticRenderFns } from "./PostLikeAvatar.vue?vue&type=template&id=62b6cec5&scoped=true&"
import script from "./PostLikeAvatar.vue?vue&type=script&lang=js&"
export * from "./PostLikeAvatar.vue?vue&type=script&lang=js&"
import style0 from "./PostLikeAvatar.vue?vue&type=style&index=0&id=62b6cec5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b6cec5",
  null
  
)

export default component.exports